"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";

const UgcRecognition = () => {
  return (
    <section className="w-full bg-white py-10">
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          
          {/* Left Card */}
          <div className="rounded-2xl bg-[#EEF7FB] p-6 sm:p-8 flex flex-col justify-between">
            <div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900">
                Recognition of University Grants Commission (UGC)
              </h3>
              <p className="mt-3 text-sm sm:text-base text-gray-700">
                List of universities recognized by the University Grants Commission
              </p>
            </div>

            <div className="mt-6 flex flex-row flex-wrap gap-4">
              <a
                href="https://www.ugc.gov.in/universitydetails/university?type=0wBmFB1Rb4JGVzq9UP/iOg=="
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-lg bg-[#0B1F33] px-5 py-3 text-sm font-medium text-white transition hover:bg-[#0E2A45]"
              >
                Go to UGC Website
                <ArrowUpRight size={18} />
              </a>
              <a
                href="/pdf/MSU_UGC_Approval_Letter_organized.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-lg bg-[#F9A21B] px-5 py-3 text-sm font-medium text-white transition hover:bg-[#0E2A45]"
              >
                UGC Approvals
                <ArrowUpRight size={18} />
              </a>
            </div>
          </div>

          {/* Right Card */}
          <div className="rounded-2xl bg-[#FFF2E3] p-6 sm:p-8 flex flex-col justify-between">
            <div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900">
                Proforma for Inspection by University Grants Commission
              </h3>
              <p className="mt-3 text-sm sm:text-base text-gray-700">
                Proforma for submission of information by State Private Universities
                for ascertaining their norms and standards
              </p>
            </div>

            <div className="mt-6">
              <a
                href="https://cdn.msu.edu.in/pdf/UGC-Proforma-MSU.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-lg bg-[#F9A21B] px-5 py-3 text-sm font-medium text-white transition hover:bg-[#E89112]"
              >
                Go to UGC Proforma for MSU
                <ArrowUpRight size={18} />
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default UgcRecognition;
